import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import {
    selectEmail,
    selectSuccess,
    selectValidity,
    sendAPIRequest,
    selectUserUuid,
    selectPaymentSettingsStatus,
} from './signupSlice'
import {selectName} from '../family/familySlice';
import { selectEventsData } from '../events/eventsSlice'
import { tabletMinWidth, mobileWidth } from '../../mixins'
import SignupInput from './SignupInput'
import UIButton from '../../UI/UIButton'
import MainHeadline from '../../UI/MainHeadline'
import MainDescription from '../../UI/MainDescription'
import { useStickyButtonStyles } from '../../helper/useStickyButtonStyles'
import { selectLandingType } from '../plans/plansSlice';
import HeaderLogo from '../../UI/HeaderLogo'
import { browserName } from 'react-device-detect'
import GoogleSignInButton from '../../UI/GoogleSignInButton'
import { setAmplitudeUserProperties } from '../../analytics/amplitude'

const SignupWrapper = styled.div`
    @media screen and (max-width: ${tabletMinWidth}px) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }
`;

const FormWrapper = styled.div`
    border-radius: 48px;
    
    @media screen and (max-width: ${mobileWidth}px) {
        padding: 30px 8px 20px;
        border-radius: 30px;
    }
`;

const isEmbeddedBrowsers =
  ['Facebook', 'Instagram', 'Messenger'].includes(browserName) ||
  /FBAN|FBAV|FBMS|FB_IAB|FB4A|FBAN\/Messenger/.test(navigator.userAgent);

const SignupScreen = ({ history }) => {
    const { t } = useTranslation();
    const isValid = useSelector(selectValidity);
    const email = useSelector(selectEmail);
    const name = useSelector(selectName);
    const isSuccess = useSelector(selectSuccess);
    const dispatch = useDispatch();
    const eventsData = useSelector(selectEventsData);
    const landingType = useSelector(selectLandingType);
    const [initEventSent, setInitEventStatus] = useState(false);
    const userUuid = useSelector(selectUserUuid);
    const { stickyButtonStyles } = useStickyButtonStyles();
    const isIntroOffer = landingType === 'intro_offer';
    const isGoogleAuthFlow = !isEmbeddedBrowsers;
    const settingsStatus = useSelector(selectPaymentSettingsStatus);

    const onBtnClick = () => {
        window?.ttq?.track('Contact', {});
        sendAnalyticsEvents(EVENTS.onboardingEnterEmailSubmitted, eventsData);
        dispatch(sendAPIRequest(decodeURIComponent(email), decodeURIComponent(name), landingType, userUuid))
    };

    useEffect(() => {
        if (initEventSent) return;

        sendAnalyticsEvents(EVENTS.onboardingEnterEmailShown, eventsData);
        setInitEventStatus(true)
    }, [initEventSent, eventsData]);

    useEffect(() => {
        if (isSuccess && settingsStatus) {
            // RedditPixel.track('SignUp', {'user_email': email});
            setAmplitudeUserProperties({ email: decodeURIComponent(email) });
            window?.ttq?.track('CompleteRegistration', {});
            sendAnalyticsEvents(EVENTS.signupSuccess, eventsData);
            history.push(isIntroOffer ? '/checkout' : '/creating-your-profile')
        }
    }, [isSuccess, history, eventsData, email, isIntroOffer, settingsStatus]);


    return (
			<>
				{isIntroOffer && <HeaderLogo />}
				<SignupWrapper>
					<div>
						<FormWrapper>
							<MainHeadline>{t('what_is_your_email')}</MainHeadline>
							<MainDescription customMargin={'0 0 32px 0'}>
								{t('enter_your_email')}
							</MainDescription>
              {isGoogleAuthFlow && <GoogleSignInButton />}
							<SignupInput />
						</FormWrapper>
					</div>
					<UIButton
						onClick={onBtnClick}
						disabled={!isValid}
						bottomPosition={'16px'}
						stickyProps={stickyButtonStyles}
						customStyles={`${isIntroOffer && 'min-height: 56px;'}`}
					/>
				</SignupWrapper>
			</>
		);
};

export default SignupScreen
